import { createContext } from "react";
import type {
  ContextLink,
  DocumentModel,
} from "@bindery/shared/corpus/document";
import type { ReferenceSelection } from "./reference-lookup";

export interface ReferenceLookupEntry {
  /** Opens the lookup drawer; `trigger` gets focus back when it closes. */
  open: (selection: ReferenceSelection, trigger: HTMLElement | null) => void;
  /** Opens a context link over its complete span. */
  openContextLink: (
    link: ContextLink,
    model: DocumentModel,
    trigger: HTMLElement | null,
  ) => void;
  /** The context link the open drawer was opened from, if any. */
  activeLinkId: string | null;
}

export const ReferenceLookupContext =
  createContext<ReferenceLookupEntry | null>(null);
